export default __webpack_public_path__ + "static/media/foto_identidade.3b3c2938.png";